export enum LoginStep {
  Login = "Login",
  Configure2FA = "Configure2FA",
  Configure2FAVerify = "Configure2FAVerify",
  Confirm2FA = "Confirm2FA",
  ResetPasswordRequest = "ResetPasswordRequest",
  ResetPasswordRequestComplete = "RestPasswordRequestComplete",
  Recover2FA = "Recover2FA",
  ContactSupport = "ContactSupport",
  StaffUpgradeTwoFaRequired = "StaffUpgradeTwoFaRequired",
}

export enum UserContext {
  Arena = "arena",
  Global = "global_",
}
